<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit" @submit.prevent="save">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-row style="display: block; margin-left: 10%; margin-right: 10%; margin-top: 15px">
          <VehicleNumberInput
            :value="carNumber"
            label="Госномер"
            :required="true"
            outlined
            dense
            @input="carNumber = $event"
          />

          <v-autocomplete
            v-model="selectedSubscriber"
            :items="subscribers"
            :item-text="formatSubscriber"
            prepend-inner-icon="mdi-account"
            item-value="id"
            :rules="roleName === 'checkpoint-admin' ? abonentRules : []"
            label="Абонент"
            outlined
            dense
            flat
            :loading="isLoadingSubscribers"
          ></v-autocomplete>
          <v-switch
            class="mt-0"
            v-model="notificationPassage"
            flat
            inset
            color="#85B285"
            label="Уведомление о проезде автомобиля"
          >
          </v-switch>
          <div style="display: block; text-align: center;">
            <v-btn
              outlined
              class="text-none mb-2 px-2 btn-code"
              rounded
              dark
              :disabled="!valid"
              @click="save"
            >
              Сохранить
            </v-btn>
          </div>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify; font-family: Arial, sans-serif;">
              <p>
                <strong>Здесь вы можете добавить новый номер автомобиля для распознавания.</strong>
              </p>
              <p>
                <br>Если вы не нашли своего абонента в списках, возможно,
                он ещё не зарегистрировался в домофоне, или у него уже привязан госномер автомобиля.
                <br><br>
                Вы можете создать временного абонента и указать ему нужный номер автомобиля. Раздел "гостевые пропуска".
                <span v-if="isResComplex">
                  <br><br>Государственный номер будет добавлен ко всем шлагбаумам.
                </span>
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import VehicleNumberInput from '@/components/VehicleNumberInput.vue';

export default {
  mixins: [ruDateFormatMixin],
  components: { VehicleNumberInput },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    barrier: {
      type: Object,
    },
    doorphones: {
      type: Array,
    },
    id: {
      type: Number,
    },
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
    isResComplex: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      valid: true,
      isDisplaySmall: false,
      notificationPassage: false,
      formValid: false,
      carNumber: '',
      searchInput: '',
      selectedSubscriber: null,
      subscribers: [],
      menu: false,
      isLoadingSubscribers: false,
      filterAbonents: {},
      abonentRules: [
        v => !!v || 'Обязательное поле.',
      ],
    };
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    formatSubscriber () {
      return (subscriber) => {
        return `${subscriber.telephone} (${subscriber.address})`;
      };
    },
  },
  methods: {
    ...mapActions({
      loadAbonents: 'Abonents/loadAbonents',
      simpleUpdateAbonent: 'Abonents/simpleUpdateAbonent',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    save () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        const carNumberTrimmed = (this.carNumber || '').toString().replace(/\s/g, '').trim();
        if (!carNumberTrimmed) {
          this.$flash_warning('Госномер обязателен');
          return;
        }
        if (this.valid) {
          if (this.date && this.date.length !== 2 && this.date.length !== 0) {
            this.$flash_danger('Выберите две даты или оставьте поле пустым.');
            return;
          }

          this.close();
          const tasks = [];
          if (this.selectedSubscriber) {
            const dataManagement = {
              car_number: [carNumberTrimmed],
            };
            const updateAbonentTask = this.simpleUpdateAbonent({
              idAbonent: this.selectedSubscriber,
              dataAbonent: dataManagement,
            });

            tasks.push(updateAbonentTask);
          }
          const saveTask = new Promise((resolve, reject) => {
            try {
              this.$emit('save', 'add', carNumberTrimmed, this.notificationPassage, this.date);
              resolve();
            } catch (error) {
              reject(error);
            }
          });
          tasks.push(saveTask);
          Promise.all(tasks)
            .then(() => {
              this.$flash_success('Все изменения успешно сохранены!');
            })
            .catch(() => {
              this.$flash_warning('Ошибка при выполнении одного из действий');
            });
        }
      });
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.carNumber = '';
      this.notificationPassage = false;
      this.selectedSubscriber = null;
      this.$emit('update:active', false);
    },
    async getData () {
      let doorphoneIds = [];
      if (this.barrier && this.barrier.doorphones) {
        doorphoneIds = this.barrier.doorphones.map(doorphone => doorphone.id);
      } else {
        doorphoneIds = this.doorphones.map(doorphone => doorphone.id);
      }

      if (doorphoneIds.length === 0) {
        this.$flash_danger('Нет привязанных домофонов');
        return;
      }
      this.filterAbonents.doorphone_id = doorphoneIds.join(',');

      this.isLoadingSubscribers = true;
      this.loadAbonents({
        filters: this.filterAbonents,
      })
        .then((data) => {
          this.subscribers = data.abonents.filter(subscriber => !subscriber.car_number);
        })
        .catch((err) => {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          } else {
            this.$flash_warning('Ошибка при загрузке абонентов');
          }
        })
        .finally(() => {
          this.isLoadingSubscribers = false;
        });
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.card-completion {
  display: flex;
}
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 71px;
  max-height: 71px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  width: 100%;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-code {
  width: 100%;
  max-width: 250px;
  background-color: #E0B389;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.box-2 {
  grid-column: 1 / 3;
}
.box-3 {
  grid-column: 1 / 3;
  grid-row: 4 / 5;
}
.border {
  border-radius: 16px;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .grid-container {
    display: block;
  }
  .card-completion {
    display: block;
  }
  .text-info {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .code-designation {
    display: none;
  }
  v-card-title {
    padding: 0;
  }
}
@media screen and (max-width: 350px) {
  .v-text-field-like {
    width: 210px;
  }
}
</style>
